import { themeState } from '../state/theme.js';

export function useTheme() {
  return themeState.value;
}
